// Get a subset of an array
export function subarray<T>(params: {
  data: T[];
  start: number;
  end: number;
}): T[] {
  return params.data.slice(params.start, params.end);
}
